import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
  LOCALE_ID,
} from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';

// Register German locale
registerLocaleData(localeDe);
import { provideClientHydration } from '@angular/platform-browser';
import {
  HttpClient,
  provideHttpClient,
  withFetch,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { loadingInterceptor } from './interceptors/loading.interceptor';
import {
  BrowserAnimationsModule,
  provideAnimations,
} from '@angular/platform-browser/animations';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { httpInterceptorProviders } from './interceptors';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActiveUserStore } from './stores/user/active-user.state';
import { LeafletMapboxService } from './services/leaflet-mapbox.service';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { HttpLoaderFactory } from './utility/translate-loader';
import { DialogService } from 'primeng/dynamicdialog';

function appInitializerFactory(userStore: any) {
  return () => userStore.checkAuthStatus();
}

function mapStylePrefetchFactory(mapboxService: LeafletMapboxService) {
  return () => {
    mapboxService.prefetchAllStyles();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'de' },
    MessageService,
    DialogService,
    ConfirmationService,
    importProvidersFrom([BrowserAnimationsModule]),
    provideRouter(routes),
    // todo: use it with appInits over socket-initializer, or initialize in app.component?
    //SocketService,
    //SocketInitializerService,
    //{
    //  provide: APP_INITIALIZER,
    //  useFactory: (socketInitializer: SocketInitializerService) =>
    //    socketInitializer.initializeSocket(),
    //  multi: true,
    //  deps: [SocketInitializerService],
    //},
    httpInterceptorProviders,
    provideClientHydration(),
    provideHttpClient(
      withFetch(),
      withInterceptorsFromDi(),
      withInterceptors([loadingInterceptor])
    ),
    provideAnimations(),
    provideStore(),
    provideEffects(),
    provideStoreDevtools({
      maxAge: 25, // Retains last 25 states
      logOnly: !isDevMode(), // Restrict extension to log-only mode
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
      trace: false, // If set to true, will include stack trace for every dispatched action, so you can see it in trace tab jumping directly to that part of code
      traceLimit: 75, // maximum stack trace frames to be stored (in case trace option was provided as true)
      connectInZone: true, // If set to true, the connection is established within the Angular zone
    }),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [ActiveUserStore], // Inject ActiveUserStore
      multi: true, // Allows multiple initializers
    },
    {
      provide: APP_INITIALIZER,
      useFactory: mapStylePrefetchFactory,
      deps: [LeafletMapboxService],
      multi: true,
    },
  ],
};
